import { ActivatedRoute, Params } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { config } from '../../../config/config';
import { PlaceCategory } from '../constants/constant';
import { FacebookLoginButtonComponent } from './facebook.login.button/facebook.login.button.component';
import { SocialLoginPopupComponent } from './social.login.popup/social.login.popup.component';
import { SubscriptionDisposable } from './subscription.disposable';
import { isInternetExplorer } from '../../utils/broswerCheck';
import { MediaQueryService } from '../../services/media.query.service';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { debounceTime } from 'rxjs/operators';

export class BaseComponent extends SubscriptionDisposable {
    public allRouteParams: Params;
    public mobileMenuTitle = 'More Options';
    public isMobile = false;
    public isMobileForLargeFeature = false;
    public isSmallPC = false;
    public isSmallestPC = false;
    public isExSmallMobile = false;
    public noChangeUrlWhenRedirect = true;
    public isIE = false;

    constructor(public componentOptions: BaseComponentOption = new BaseComponentOption()) {
        super();
        this.noChangeUrlWhenRedirect = this.isScriptSolution;
        if (window.location.href.indexOf('localhost:4200') >= 0) {
            this.noChangeUrlWhenRedirect = false;
        }
        this.setViews();
        this.isIE = isInternetExplorer();

        if (componentOptions.activatedRoute) {
            let allParams = componentOptions.activatedRoute.params;
            let parent = componentOptions.activatedRoute.parent;
            let child = componentOptions.activatedRoute.firstChild;
            while (!isNullOrUndefined(child)) {
                allParams = allParams.combineLatest(child.params, (a, b) => Object.assign({}, a, b));
                child = child.firstChild;
            }

            while (!isNullOrUndefined(parent)) {
                allParams = allParams.combineLatest(parent.params, (a, b) => Object.assign({}, a, b));
                parent = parent.parent;
            }

            allParams.takeUntil(this.isDestroyed).subscribe((params) => {
                if (params.category) {
                    params.category = PlaceCategory.getPlaceCategoryValue(params.category);
                }

                this.allRouteParams = params;
            });
        }

        this.hideSkeleton();

        const resizeObs = fromEvent(window, 'resize');
        resizeObs.pipe(debounceTime(500)).subscribe((data) => {
            this.setViews();
        });
    }

    private setViews() {
        this.isMobile = window.innerWidth <= config.phoneSizeWidth;
        this.isSmallPC = window.innerWidth < config.smallPCSizeWidth && !this.isMobile;
        this.isSmallestPC = window.innerWidth <= config.smallestPCSizeWidth && !this.isMobile;
        this.isExSmallMobile = window.innerWidth < config.exSmallphoneSizeWidth;

        // for trip planner
        this.isMobileForLargeFeature = window.innerWidth <= 1360;
    }

    public get isFacebookLoggedIn() {
        return FacebookLoginButtonComponent.isUserLoggedWithFacebook;
    }

    public get isSocialLoggedin() {
        return SocialLoginPopupComponent.isUserLoggedIn;
    }

    public get isScriptSolution() {
        return !!(
            document.getElementById('imgoingcalendar-wrapper') || document.getElementById('imgoingcalendar-wrapper-wix')
        );
        // return !config.serverDomain.includes(window.location.hostname) && window.location.hostname !== 'localhost';
    }

    public hideSkeleton() {
        let wholeSpinner = document.getElementById('skeleton-mask');
        if (wholeSpinner) {
            wholeSpinner.style.display = 'none';
        }
    }
}

export class BaseComponentOption {
    activatedRoute?: ActivatedRoute;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/base.component.ts